import { makeUseFormHook } from "./make-use-form-hook.js";
import { useForm } from "@mantine/form";

//#region src/hooks/form/use-form.ts
const useForm$1 = makeUseFormHook(useForm);

//#endregion
export { useForm$1 as useForm };